import { BASE_URL, TOPIC } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { ITopic, ITopicInput } from "models/topic";

export async function getTopics(params: string = ""):Promise<ITopic[] > {
  const response = await axios.get(BASE_URL + TOPIC + params);
  return response.data;
}
export async function addTopic(data: ITopicInput) {
  const response = await axios.post(BASE_URL + TOPIC, data);
  return response.data;
}
export async function editTopic(data: ITopicInput, id: string) {
  const response = await axios.patch(BASE_URL + TOPIC + "/" + id, data);
  return response.data;
}

export async function deleteTopic(id: string) {
  const response = await axios.delete(BASE_URL + TOPIC + "/" + id);
  return response.data;
}

export const TopicCells: HeadCell[] = [   
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "T_name",
  },
  {
    id: "nameAr",
    numeric: false,
    disablePadding: false,
    label: "T_name_Ar",
  },
  {
    id: "description",
    numeric: false,
    disablePadding: false,
    label: "T_description",
  },
  {
    id: "descriptionAr",
    numeric: false,
    disablePadding: false,
    label: "T_description_Ar",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];
